/* eslint-disable no-useless-catch */
import { useState } from "react";
import useAPIHandler from "../hook/use-api-handler";

export const useAuth = () => {
  const [loading, setLoading] = useState(false);
  const { fetchData } = useAPIHandler();

  // Login function
  const login = async (email, password) => {
    setLoading(true);

    try {
      const response = await fetchData({
        data: { email, password },
        url: "auth/signin",
        method: "POST",
      });

      return response;
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  // Signup function
  const signup = async (signupData) => {
    setLoading(true);

    try {
      const {
        first_name,
        last_name,
        email,
        phone,
        user_type,

        password,
      } = signupData;

      return await fetchData({
        data: {
          first_name,
          last_name,
          email,
          phone,
          user_type,
          // org_name: orgName,

          password,
        },
        url: "/auth/signup",
        method: "POST",
      });
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  // Logout function
  const logout = () => {
    // Add any additional logout logic, like clearing tokens
  };

  return {
    loading,
    login,
    signup,
    logout,
  };
};
